// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Кадрові запити» (HR requests, ключ `hr`, група `office`). */
export const hrRequestsManifest: IModuleManifest = {
  key: 'hr',
  group: 'office',
  slug: 'hr-requests',
  prefix: 'HRR',
  name: { en: 'HR requests', uk: 'Кадрові запити' },
  entities: [
    { key: 'hr', slug: 'hr', name: { en: 'HR requests', uk: 'Кадрові запити' }, main: true },
    { key: 'hr_request_approval', slug: 'hr-request-approval', name: { en: 'HR request Approvals', uk: 'Погодження' }, main: false },
    { key: 'hr_request_document', slug: 'hr-request-document', name: { en: 'HR request Documents', uk: 'Документи' }, main: false },
    { key: 'hr_request_type', slug: 'hr-request-type', name: { en: 'HR request Types', uk: 'Типи запитів' }, main: false },
    { key: 'hr_request_status', slug: 'hr-request-status', name: { en: 'HR request Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/hrRequestsSlice').then((m) => m.hrRequestsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
